import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@icon/scrumHaltSprint.svg'
import _imports_1 from '@icon/continuousHaltSprint.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-68983e99"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "label-pic is-red" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!
  const _component_NotificationSprintHeader = _resolveComponent("NotificationSprintHeader")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_NotificationTemplate = _resolveComponent("NotificationTemplate")!

  return (_openBlock(), _createBlock(_component_NotificationTemplate, { notification: _ctx.notification }, {
    pic: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.sprintContent.sprint.continuousSprint)
          ? (_openBlock(), _createBlock(_component_icon, {
              key: 0,
              data: _imports_0,
              class: "label-pic__icon",
              width: "var(--icon-24)",
              height: "var(--icon-24)"
            }))
          : (_openBlock(), _createBlock(_component_icon, {
              key: 1,
              data: _imports_1,
              class: "label-pic__icon",
              width: "var(--icon-24)",
              height: "var(--icon-24)"
            }))
      ])
    ]),
    title: _withCtx(() => [
      _createVNode(_component_BaseSubHeading, {
        class: "is-flex",
        size: "large",
        color: "monochrome-06",
        darkColor: "monochrome-03",
        weight: "500"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_NotificationSprintHeader, { sprint: _ctx.sprintContent }, null, 8, ["sprint"]),
          _createElementVNode("span", {
            style: _normalizeStyle({ color: `var(--${_ctx.haltedColor})` }),
            class: "sprint-sequence-number"
          }, " Halted ", 4)
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      _createVNode(_component_BaseSubHeading, {
        size: "medium",
        color: "monochrome-06",
        darkColor: "monochrome-03",
        weight: "400",
        className: "notification__desc"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.sprintContent?.haltReasonSummary), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["notification"]))
}